import React, { Component } from 'react'
import { Modal, Input }     from 'antd'
import classnames           from "classnames"

import './styles.scss'

export default class InputModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      modal_visible : false,
      text:''
    }
  }

  open = _ => this.setState({modal_visible:true})

  close = _ => this.setState({modal_visible:false})

  on_input_change = e => {
    const { name, value } = e.target||e||{}
    this.setState({...this.state, ...{[name]:value}})
  }

  render() {
    const {modal_visible, text} = this.state
    const {title, placeholder, on_close} = this.props

    return (
      <Modal
        className={'modal-contact-us'}
        visible  = {modal_visible}
        onOk     = {()=> on_close(text)}
        onCancel = {()=> this.close()}>
        <div className={'user-input'}>
          <label>{title}</label>
          <Input.TextArea
            placeholder={placeholder} name='text' value={text}
            className={classnames({ 'required': !text })}
            onChange={this.on_input_change} autosize={{ minRows: 4, maxRows: 10 }} autoFocus/>
        </div>
      </Modal>
    )
  }
}
